<template>
    <div class="tracking-timeline">
        <div
            v-for="(item, index) in items"
            :key="index"
            class="tracking-timeline__list"
        >
            <TimelineCircle  :status="getStatus(item.status)" />
            <p class="tracking-timeline__desc">
                {{ item.status_str }}
            </p>
        </div>
    </div>
</template>
<style scoped>
    .tracking-timeline {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 800px;
        margin: 0 auto;
    }
    
    .tracking-timeline__list {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        position: relative;
        z-index: 1;
    }
    .tracking-timeline__icon {
        width: 56px;
        height: 56px;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px dashed #ddd ;
        background-color: white;
        font-size: 18px;
        color: #6c757d;
    }

    .tracking-timeline__desc {
        font-weight: 900;
        font-size: 13px;
        padding-top: 12px;
    }

    .tracking-timeline__icon.fail {
        background-color: #d32f2f;
        border: 1px solid #d32f2f;
        color: white;
    }
    
    .tracking-timeline__icon.success {
        color: #0a58ca;
        background-color: #C5E0FE;
        border: 1px solid #C5E0FE;
    }

    .tracking-timeline:after {
        content: "";
        position: absolute;
        top: 28px;
        left: 50%;
        transform: translateX(-50%);
        height: 2px;
        width: calc(100% - 256px);
        background-color: #E4E9EF;
    }
</style>
<script>
import TimelineCircle from './TimelineCircle.vue';
export default {
    name: "TrackingTimeline",
    props: {
        items: {
            type: Object,
            required: true,
        },
        success: {
            type: Object,
            required: false,
        },
        fail: {
            type: Array,
            required: false,
        },
    },
    components: {
        TimelineCircle,
    },
    methods: {
        getStatus(index) {
            console.log(index)
            console.log(this.success)
            if (this.success.includes(index)) {
                return true;
            }
            else if (this.fail.includes(index)) {
                return false;
            }
            else {
                return null
            }
        }
    },
}
</script>